import { FormControlProps } from "react-bootstrap/FormControl";

import { useWindowDimensions } from "@/hooks/useWindowDimensions";

import { FormattedFormControl } from "@/components/FormControl/FormattedFormControl";
import { SkeletonWrapper } from "@/components/SkeletonWrapper";

type Props = FormControlProps & {
	skeleton?: boolean;
};

export function OxygenSaturation({ skeleton, ...rest }: Props) {
	const { width } = useWindowDimensions();

	return (
		<>
			{skeleton ? (
				<SkeletonWrapper />
			) : (
				<FormattedFormControl
					formattedFormControlClassName="form-control-solid"
					label={`Saturação de Oxigênio ${(width > 444 && "(%SpO2)") || ""}`}
					mask="000"
					id={rest.id}
					isMaskedInput
					{...(rest as any)}
				/>
			)}
		</>
	);
}
